import React__default from 'react';
import { Olapic as Olapic$1 } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import { RuntimeContext } from '../../runtime-context.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import { withAnchor } from '../../hocs/with-anchor.js';

const CmsOlapic = ({ meta  })=>{
    const { locale  } = useIntl();
    const { olapic: { apiKey , url  } ,  } = React__default.useContext(RuntimeContext);
    return /*#__PURE__*/ React__default.createElement(Olapic$1, {
        apiKey: apiKey,
        instance: meta.instance,
        locale: locale.replace('-', '_'),
        olapic: meta.olapic,
        src: url,
        tags: meta.tags
    });
};
var Olapic = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withAnchor)(CmsOlapic);

export { CmsOlapic, Olapic as default };
//# sourceMappingURL=Olapic.js.map
